import React from 'react'
import { makeStyles } from '@material-ui/core'
import { FontWeight, Color } from 'theme/style'
import { API_PickupPointData } from 'app/api'

const useStyles = makeStyles((theme) => ({
  pointData: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  pickupPointLogo: {
    width: '60px',
    height: '60px',
    flex: '0 0 60px',
    borderRadius: '50%',
    overflow: 'hidden',
    border: '3px solid ' + Color.Background,
    objectFit: 'cover',
    objectPosition: 'center'
  },
  pickupPointInfo: {
    marginLeft: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  pickupPointName: {
    ...theme.typography.body2,
    width: '100%',
    textAlign: 'left',
    fontWeight: FontWeight.SemiBold,
    color: Color.TextPrimary
  },
  pickupPointAddress: {
    ...theme.typography.body2,
    textAlign: 'left',
    width: '100%',
    color: Color.TextSecondary
  },
  pickupPointRating: {
  },

}))

interface PickupPointDetailsProps {
  pickupPointData?: API_PickupPointData | null
}

const PickupPointDetails = ({ ...props }: PickupPointDetailsProps) => {
  const classes = useStyles()

  if (props.pickupPointData == null) return <></>

  return (
    <div className={classes.pointData}>
      <img className={classes.pickupPointLogo} src={props.pickupPointData?.ul} alt={'logo'} />
      <div className={classes.pickupPointInfo}>
        <div className={classes.pickupPointName}>{props.pickupPointData?.de}</div>
        <div className={classes.pickupPointAddress}>{props.pickupPointData?.ad}, {props.pickupPointData?.zi} {props.pickupPointData?.ci} ({props.pickupPointData?.dp})</div>
        {/* <div className={classes.pickupPointRating}>
        </div> */}
      </div>
    </div>
  )
}

export default PickupPointDetails
